__webpack_require__.p = "/competition/";